import { PageLayout } from "../../components/page-layout";

export const NotFoundPage = () => {
  return <PageLayout>NOT FOUND PAGE</PageLayout>;
};
